import React from 'react'

export default () =>
<div id="footer">
  A <a href="http://staystatic.github.io">Stay Static</a> Sample Site
</div>



// WEBPACK FOOTER //
// ./src/components/Footer.js